import React from 'react';
import Graph from './graph';

export default function Monitored({ href, bin }) {
  const timeRange = bin?.properties?.role === 'ingredient' ? '24 hours' : '4 weeks';

  return (
    <>
      <h3>Level History ({timeRange})</h3>
      <Graph href={href} role={bin.properties.role} />
    </>
  );
}
